import { styled } from "@mui/material/styles";
import { Drawer, Box, Fab } from "@mui/material";

const drawerWidth = 300;

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
  },
}));

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));

export const MainContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open?: boolean }>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginRight: 0,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  }),
}));

export const FilterFab = styled(Fab)(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(12),
  right: theme.spacing(-4),
  transform: "rotate(-90deg)",
}));

export const RootContainer = styled(Box)(({ theme }) => ({
  maxWidth: "90vw",
})); 